module.exports = __webpack_public_path__ + "assets/img/img-care-banner@2x.5904826.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/care/img-care-banner@2x.jpg
// module id = 1095
// module chunks = 1